import { BehaviorSubject, Observable } from "rxjs"
import { ApiError } from "../model/error.model"
import { GenerateOTPRes, ValidateOTPRes } from "../service/response/registration.response"

let _selectedLang = new BehaviorSubject<string>("")
let _loading = new BehaviorSubject<boolean>(false)
let _generateOtpRes = new BehaviorSubject<GenerateOTPRes | ApiError | null>(null)
let _validateOtpRes = new BehaviorSubject<ValidateOTPRes | ApiError | null>(null)

export const RegistrationStore = {
    getSelectedLang: (): string => {
        return _selectedLang.value
    },
    setSelectedLang: (newLang: string) => {
        _selectedLang.next(newLang)
    },
    getSelectedLangObservable: (): Observable<string> => {
        return _selectedLang.asObservable()
    },
    getLoading: (): boolean => {
        return _loading.value
    },
    setLoading: (loading: boolean) => {
        _loading.next(loading)
    },
    getLoadingObservable: (): Observable<boolean> => {
        return _loading.asObservable()
    },
    getGenearteOtpRes: (): GenerateOTPRes | ApiError | null => {
        return _generateOtpRes.value
    },
    setGenearteOtpRes: (generateOTPRes: GenerateOTPRes | ApiError | null) => {
        _generateOtpRes.next(generateOTPRes)
    },
    getGenearteOtpResObservable: (): Observable<GenerateOTPRes | ApiError | null> => {
        return _generateOtpRes.asObservable()
    },
    getValidateOtpRes: (): ValidateOTPRes | ApiError | null => {
        return _validateOtpRes.value
    },
    setValidateOtpRes: (validateOTPRes: ValidateOTPRes | ApiError | null) => {
        _validateOtpRes.next(validateOTPRes)
    },
    getValidateOtpResObservable: (): Observable<ValidateOTPRes | ApiError | null> => {
        return _validateOtpRes.asObservable()
    },
}